import { scopeFor, ScopeNotReadyError } from "@/queries/scope";

/** The part of the root store this reads. Not `RootStore` itself: every store
 *  imports this file, and the root store imports every store. */
export interface FlagSource {
  featureFlags: { isEnabled(key: string): boolean };
}

/**
 * The scope to cache `slug`'s reads and writes under, or `null` to behave the
 * way the switch-off path does: the domain's kill switch is off, or the session
 * has not said who is signed in yet, so there is no key to cache under.
 *
 * `flag` is the same switch the domain's hooks take (`useScopedQuery`): a
 * domain's kill switch, or `null` (the default) once the domain reads only
 * through Query, when the answer is `null` only before the session resolves. A writer or loader passes what its domain's hooks pass, or it
 * stops touching the cache the hooks read from.
 */
export function queryCacheScope(
  rootStore: FlagSource,
  slug: string,
  owner: string,
  flag: string | null = null,
) {
  if (flag !== null && !rootStore.featureFlags.isEnabled(flag)) return null;
  try {
    return scopeFor(slug);
  } catch (error) {
    if (!(error instanceof ScopeNotReadyError)) throw error;
    console.warn(`[${owner}] used before the session resolved; not cached`, { slug });
    return null;
  }
}
